import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import DealerSignupSection from 'components/DealerSignupSection'
import SectionHeader from 'components/SectionHeader'
import { useTranslation } from 'react-i18next'

const AboutUsPage = () => {
  const { t } = useTranslation()
  return (
    <Box sx={{ position: 'relative', minHeight: '80vh' }}>
      <FixedWidthContainer>
        <SectionHeader title={t('aboutUs.title')} />

        <Box sx={{ mt: 4 }}>
          <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
            {t('aboutUs.paragraph1')}
          </Typography>
          <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
            {t('aboutUs.paragraph2')}
          </Typography>
          <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
            {t('aboutUs.paragraph3')}
          </Typography>
        </Box>
        <Box sx={{ mt: 6 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                component='img'
                src='/about_us_1.jpg'
                alt='About Us 1'
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: 3
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                component='img'
                src='/about_us_2.jpg'
                alt='About Us 2'
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: 3
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                component='img'
                src='/about_us_3.jpg'
                alt='About Us 3'
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: 3
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                component='img'
                src='/about_us_4.jpg'
                alt='About Us 4'
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: 3
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </FixedWidthContainer>

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%'
        }}
      >
        <DealerSignupSection />
      </Box>
    </Box>
  )
}

export default AboutUsPage
